import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import { ReactNode } from "react";
import { TripInformation } from "./TripInformation";

type TripBodyProps = {
  tripInformation: TripInformation;
  timeTable: ReactNode;
};

const TripBody = ({ tripInformation, timeTable }: TripBodyProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography marginTop={5} variant="h4" gutterBottom>
        {t("trips.what-do-we-do-title")}
      </Typography>
      <Trans i18nKey={tripInformation.moreInformation.what}>
        <p>First paragraph</p>
        <p>
          Second paragraph
          <ul>
            <li>Item 1</li>
            <li>Item 2</li>
            <li>Item 3</li>
          </ul>
        </p>
        <p>Third paragraph</p>
        <p>Fourth paragraph</p>
        <p>Fifth paragraph</p>
      </Trans>
      <Typography marginTop={5} variant="h4" gutterBottom>
        {t("trips.what-does-price-include-title")}
      </Typography>
      <Trans i18nKey={tripInformation.moreInformation.price}>
        <p>First paragraph</p>
        <ul>
          <li>Item 1</li>
          <li>Item 2</li>
          <li>Item 3</li>
          <li>Item 4</li>
        </ul>
        <p>Second paragraph</p>
        <Typography marginTop={2} variant="h5" gutterBottom></Typography>
        <ul>
          <li>Item 1</li>
          <li>Item 2</li>
          <li>Item 3</li>
        </ul>
        <Typography marginTop={2} variant="h5" gutterBottom></Typography>
        <p>Fifth paragraph</p>
        <p>Sixth paragraph</p>
      </Trans>
      <Typography marginTop={5} variant="h4" gutterBottom>
        {t("trips.practical-title")}
      </Typography>
      <Typography marginTop={2} variant="h5" gutterBottom>
        {t("trips.practical-sub-title")}
      </Typography>
      <Trans i18nKey={tripInformation.moreInformation.practical}>
        <ul>
          <li>Item 1</li>
          <li>Item 2</li>
          <li>Item 3</li>
        </ul>
      </Trans>
      <Typography marginTop={2} variant="h5" gutterBottom>
        {t("trips.timetable-title")}
      </Typography>
      {timeTable}
      <Typography marginTop={2} variant="h5" gutterBottom>
        {t("trips.departure-point-title")}
      </Typography>
      <p>{t(tripInformation.moreInformation.departurePoint)}</p>
      {tripInformation.mapUrl && (
        <Box mt={3}>
          <iframe className="iframe-map" title="route-map" src={tripInformation.mapUrl}></iframe>
        </Box>
      )}
    </Box>
  );
};

export default TripBody;
